(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("react-dialpad", [], factory);
	else if(typeof exports === 'object')
		exports["react-dialpad"] = factory();
	else
		root["react-dialpad"] = factory();
})(window, function() {
return 